import { Link, useLocation } from "react-router-dom";
import {
    BookOpen,
    ShoppingCart,
    FileText,
    User,
} from "lucide-react";

import { useCart } from "@/lib/cart";
import { useAuth } from "@/lib/auth";

export default function MobileBottomNav () {
    const { count } = useCart();
    const { pathname } = useLocation();
    const { user } = useAuth();

    const items = [
        {
            to: "/books/written",
            icon: BookOpen,
            label: "Books",
        },
        {
            to: "/books/mcq",
            icon: FileText,
            label: "MCQ Book",
            mr: true,
        },
        {
            to: "/cart",
            icon: ShoppingCart,
            label: "Cart",
            center: true,
        },
        {
            to: "/books/ebook",
            icon: FileText,
            label: "E-Book",
            ml: true,
        },
        {
            to: user ? "/profile" : "/login",
            icon: User,
            label: user ? "Profile" : "Login",
            profile: true,
        },
    ];

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[999] bg-white border-t border-brand-light shadow-soft lg:hidden">

            <div className="flex items-center justify-between px-2 py-2 relative">

                {items.map((item, idx) => {
                    const Icon = item.icon;

                    const active =
                        pathname === item.to ||
                        (item.profile &&
                            pathname.startsWith("/profile"));

                    // CART BUTTON
                    if (item.center) {
                        return (
                            <Link
                                key={idx}
                                to={item.to}
                                className="absolute left-1/2 -translate-x-1/2 -top-6"
                            >
                                <div className="relative bg-[#08145A] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-pop border-4 border-white">

                                    <Icon className="w-6 h-6" />

                                    {count > 0 && (
                                        <span className="absolute -top-1 -right-1 bg-[#D61F1F] text-white text-[10px] font-bold rounded-full min-w-[18px] h-5 px-1 flex items-center justify-center">
                                            {count}
                                        </span>
                                    )}
                                </div>
                            </Link>
                        );
                    }

                    return (
                        <Link
                            key={idx}
                            to={item.to}
                            className={`flex flex-col items-center justify-center text-xs w-full py-2 transition-colors ${item.mr ? "mr-[15px]" : ""} ${item.ml ? "ml-[20px]" : ""} ${ active
                                    ? "text-[#08145A]"
                                    : "text-gray-500"
                                }`}
                        >

                            {/* Profile Avatar */}
                            {item.profile && user ? (
                                <div className="w-5 h-5 mb-1 rounded-full bg-[#08145A] text-white flex items-center justify-center text-[10px] font-bold">

                                    {user.name?.charAt(0)?.toUpperCase() || "U"}

                                </div>
                            ) : (
                                <Icon className="w-5 h-5 mb-1" />
                            )}

                            <span>{item.label}</span>

                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
